<template>
  <div class="message">
    <div class="message__user">
      <router-link
        v-if="messageData.writtenBy"
        class="message__user-link"
        :to="{
          name: 'UserProfile',
          params: { link: messageData.writtenBy.link },
        }"
      >
        <el-avatar class="message__user-avatar" :size="32">
          <user-avatar :userId="messageData.writtenBy.userId" :alt="messageData.writtenBy.firstName + ' ' + messageData.writtenBy.lastName" />
        </el-avatar>
        <div class="message__user-name">
          {{ messageData.writtenBy.firstName + ' ' + messageData.writtenBy.lastName }}
        </div>
      </router-link>

      <div class="message__date">
        {{ formatDateTime(messageData.message.createdOn, SHORT_DATETIME_FORMAT) }}
      </div>
    </div>
    <div class="message__text">
      {{ messageData.message.message.text }}
    </div>
  </div>
</template>

<script>
import { SHORT_DATETIME_FORMAT, formatDateTime } from '@/utils/index.js';
import UserAvatar from '@/components/profile/UserAvatar.vue';

export default {
  name: 'MessagePreview',
  props: {
    messageData: {
      type: Object,
      required: true,
    },
  },
  components: {
    UserAvatar,
  },
  data() {
    return {
      SHORT_DATETIME_FORMAT
    }
  },
  methods: {
    formatDateTime
  }
};
</script>
